module.exports = __webpack_public_path__ + "img/kybernetwork_gray.a253c837.png";